import { useState, useEffect, useMemo, useCallback, memo } from 'react'
import { SectionDetailType } from '../../@types/home'
import useTimer from '../../hooks/useTimer'

type TimeLeft = {
  hours: number
  minutes: number
  seconds: number
}

interface HotDealTimeProps {
  sectionItem: SectionDetailType
}

const HotDealTime = ({ sectionItem }: HotDealTimeProps) => {
  const [time, setTime] = useState<string>('')

  const timeLeft: TimeLeft = useTimer(time)

  const formatTwoDigits = useCallback((num: number) => {
    return num.toString().padStart(2, '0')
  }, [])

  const formattedTime = useMemo(() => {
    return ` ${formatTwoDigits(timeLeft.hours)}:${formatTwoDigits(timeLeft.minutes)}:${formatTwoDigits(
      timeLeft.seconds
    )}`
  }, [timeLeft.hours, timeLeft.minutes, timeLeft.seconds, formatTwoDigits])

  useEffect(() => {
    if (sectionItem && sectionItem?.products?.length > 0) setTime(sectionItem.products[0].sectionProductEndYmdt)
  }, [sectionItem])

  return (
    <div className='time'>
      {formattedTime} <span>남음</span>
    </div>
  )
}

export default memo(HotDealTime)
